import { connect } from "react-redux";

import { withResolvePaths } from "../../withResolvePaths";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { OptionalComponentIdExtractor } from "../../Services/ComponentIdExtraction";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";

import { ModalFormLabel, ModalFormLabelProps } from "./ModalFormLabel";

type OwnProps = ModalFormLabelProps & FormActionHandlerExecutionInjectableProps;

const mapStateToProps = (state: FullFormState, ownProps: OwnProps) => ({
    executeFormActionHandler: ownProps.executeFormActionHandler,
    isReadOnly: Boolean(state.settings.isReadOnly),
});

function ModalComponentIdExtractor(): OptionalComponentIdExtractor<ModalFormLabelProps> {
    return function* (props: ModalFormLabelProps): Iterable<string> {
        if (props.navigationPathMask) {
            yield props.navigationPathMask;
        } else if (props.relativeNavigationPath) {
            yield props.relativeNavigationPath.toLegacyPath();
        } else {
            yield props.bindingPath.toLegacyPath();
        }
    };
}

export const ModalFormLabelContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withFocusManagement(connect(mapStateToProps)(ModalFormLabel), ModalComponentIdExtractor())
    )
);
